import { Paper } from "@mui/material";
import { NeurofeedbackSessionDetailGroup } from "../../../neurofeedback-zscore-sessions/NeurofeedbackSessionDetail";
import { NeurofeedbackHeaderData } from "../../../neurofeedback-zscore-sessions/components/neurofeedback-header/NeurofeedbackSessionHeader";

type NeurofeedbackDetailPanelProps = {
	nfbItem: any;
};

export const NeurofeedbackDetailPanel = ({ nfbItem }: NeurofeedbackDetailPanelProps) => {
	return (
		<>
			<Paper sx={{ display: "flex", alignItems: "flex-start", gap: 4, flexWrap: "wrap", mb: 2, mx: 2, p: 2 }} elevation={1}>
				<NeurofeedbackHeaderData nfbSession={nfbItem} />
			</Paper>
			<NeurofeedbackSessionDetailGroup nfbSession={nfbItem} />
		</>
	);
};
